export enum CompanyType {
    basic = "basic",
    trial = "trial"
}
